function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  mutation AddDispensaryCustomer($input: dispensaryCustomerInput!) {\n    addDispensaryCustomer(customer: $input) {\n      success\n      message\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateDispensaryCustomer($input: dispensaryCustomerInput!) {\n    updateDispensaryCustomer(customer: $input) {\n      success\n      message\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  mutation ExportDispensaryCustomers($input: customerExportInput!) {\n    exportDispensaryCustomers(input: $input) {\n      success\n      message\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  mutation ExportCustomerReport($export: exportCustomerReportInput!) {\n    exportCustomerReport(export: $export) {\n      success\n      count\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  mutation UpdateCustomerSubscription($customerId: String!, $subscribed: Boolean!) {\n    updateCustomerSubscription(customerId: $customerId, subscribed: $subscribed) {\n      success\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  mutation UnsubscribeDispensaryCustomers($input: unsubscribeDispensaryCustomersInput!) {\n    unsubscribeDispensaryCustomers(input: $input) {\n      success\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import gql from 'graphql-tag';
export var addDispensaryCustomer = gql(_templateObject());
export var updateDispensaryCustomer = gql(_templateObject1());
export var exportDispensaryCustomers = gql(_templateObject2());
export var exportCustomerReport = gql(_templateObject3());
export var updateCustomerSubscription = gql(_templateObject4());
export var unsubscribeDispensaryCustomers = gql(_templateObject5());
